import React from 'react';
import { motion } from 'framer-motion';
import { Star, BadgeCheck, Quote } from 'lucide-react';
// Copywriting adaptado al mercado venezolano B2B
const testimonials = [{
  name: 'Daniela M.',
  role: 'Dueña de Boutique (Caracas)',
  initials: 'DM',
  color: 'from-pink-500 to-rose-500',
  quote: 'Antes pasaba madrugadas intentando hacer un post que quedara decente. Con las plantillas de este toolkit, armo el contenido de toda la semana en 20 minutos. Mi Instagram por fin se ve como una tienda de verdad.'
}, {
  name: 'Roberto C.',
  role: 'Servicios Técnicos (Valencia)',
  initials: 'RC',
  color: 'from-cyan-500 to-blue-500',
  quote: 'El dolor de cabeza más grande era dar el precio y que me dejaran en visto. Apliqué el guion de cierre por WhatsApp que trae el bono y cerré 4 ventas el mismo día. Este producto se paga solo.'
}, {
  name: 'Andrea P.',
  role: 'Minimarket (Barquisimeto)',
  initials: 'AP',
  color: 'from-green-400 to-emerald-600',
  quote: 'Solo la calculadora anti-inflación ya vale los $17. Estaba perdiendo plata sin darme cuenta al calcular mal la tasa en el local. Ahora cobro exacto y en segundos. ¡100% recomendado!'
}];
export function Testimonials() {
  return <section className="py-16 md:py-24 px-4 md:px-6 lg:px-8 max-w-7xl mx-auto relative" data-id="element-239">
      {/* Brillo de fondo */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-cyan-500/5 rounded-full blur-[100px] pointer-events-none" data-id="element-240" />

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.5
    }} className="text-center mb-16 relative z-10" data-id="element-241">
        <div className="inline-flex items-center px-4 py-2 rounded-full bg-yellow-500/10 border border-yellow-500/20 text-yellow-400 text-sm font-bold mb-6 tracking-wide uppercase" data-id="element-242">
          ⭐️ Casos de Éxito
        </div>
        <h2 className="font-heading text-3xl md:text-5xl font-black text-white leading-tight" data-id="element-243">
          Resultados reales de{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-green-400" data-id="element-244">
            negocios reales
          </span>
        </h2>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 relative z-10" data-id="element-245">
        {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.5,
        delay: index * 0.15
      }} className="group relative bg-[#0a0a0a] border border-white/5 rounded-3xl p-8 flex flex-col h-full hover:border-cyan-500/30 hover:bg-white/[0.02] transition-all duration-300" data-id="element-246">
            {/* Ícono de Comillas Decorativo */}
            <Quote className="absolute top-6 right-6 w-12 h-12 text-white/5 group-hover:text-cyan-500/10 transition-colors duration-300 transform rotate-180" data-id="element-247" />

            {/* Estrellas */}
            <div className="flex gap-1 mb-6" data-id="element-248">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400 drop-shadow-[0_0_8px_rgba(250,204,21,0.4)]" data-id="element-249" />)}
            </div>

            {/* Texto del Testimonio */}
            <p className="text-gray-300 text-lg mb-8 flex-grow leading-relaxed font-light relative z-10" data-id="element-250">
              "{testimonial.quote}"
            </p>

            {/* Perfil del Cliente */}
            <div className="flex items-center gap-4 border-t border-white/5 pt-6 mt-auto" data-id="element-251">
              {/* Avatar Generado por CSS */}
              <div className={`w-12 h-12 rounded-full bg-gradient-to-br ${testimonial.color} flex items-center justify-center shadow-lg flex-shrink-0`} data-id="element-252">
                <span className="font-bold text-white text-lg tracking-wider" data-id="element-253">
                  {testimonial.initials}
                </span>
              </div>

              <div data-id="element-254">
                <div className="flex items-center gap-1.5" data-id="element-255">
                  <p className="font-heading font-bold text-white text-lg tracking-tight" data-id="element-256">
                    {testimonial.name}
                  </p>
                  {/* Badge de Compra Verificada */}
                  <BadgeCheck className="w-4 h-4 text-cyan-400" title="Compra Verificada" data-id="element-257" />
                </div>
                <p className="text-sm text-gray-500" data-id="element-258">{testimonial.role}</p>
              </div>
            </div>
          </motion.div>)}
      </div>
    </section>;
}